<script lang="ts">
	import { page } from '$app/state';
</script>

<div class="flex items-center gap-3 mb-12">
	{#if page.data.applicationSetting?.logoUrl}
		<img
			src={page.data.applicationSetting.logoUrl}
			alt={`Logo ${page.data.applicationSetting?.gymName ?? "CrossFit Les Sables d'Olonne"}`}
			class="h-12 w-12 object-contain"
		/>
	{:else}
		<img
			src="/logo-box.webp"
			alt="Logo CrossFit Les Sables d'Olonne"
			class="h-12 w-12 object-contain"
		/>
	{/if}
	<div class="flex flex-col">
		<span class="font-display text-base font-bold text-foreground leading-tight"
			>{page.data.applicationSetting?.gymName ?? "CrossFit Les Sables d'Olonne"}</span
		>
	</div>
</div>
